// removed by extract-text-webpack-plugin
module.exports = {"balance":"_3ag98ZoMXj","balanceLabel":"_1XN9xZGoqg","relationship":"_1h-aj3oHHp split","email":"jjJU79YkCW","mdSheet":"_3Q9WiGKW-j","actions":"VYN6_UPV6C","closed":"_2EL_9_sHhm"};


//////////////////
// WEBPACK FOOTER
// ./src/assets/scripts/components/containers/secure/Dashboard/AccountList/AccountCard/AccountCard.module.less
// module id = 975
// module chunks = 3